<template>
  <v-card :class="['bottom-sheet', {active: show?true:false}]">
    <v-icon @click="$emit('close')" class="closeBtn">keyboard_backspace</v-icon>
    <div class="bottom-sheet-head">
      <h3>
        <flag class="flag" :iso="selectedProfile.nationality" />
        {{selectedProfile.name}}
      </h3>
    </div>
    <div class="profile">
      <UserData :user-data="selectedProfile" />
      <v-tabs fixed-tabs background-color="white" slider-color="light-green accent-4">
        <v-tabs-items v-model="tab">
          <v-tab-item :value="'Übersicht'">
            <UserBio :user-data="selectedProfile" />
          </v-tab-item>
          <v-tab-item :value="'Karriere'">
            <v-card class="overview-career" flat>
              <v-timeline v-if="sortedHistory.length >0">
                <v-timeline-item
                  v-for="(history,i) in sortedHistory"
                  :key="i"
                  color="light-green accent-4"
                  :right="i%2===0"
                  :left="i%2===1"
                  small
                >
                  <HistoryCard :history="history" :side="i"></HistoryCard>
                </v-timeline-item>
              </v-timeline>
              <h3 v-else>Bisher keine Karriere angegeben.</h3>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Gallery'">
            <v-card class="overview-career" flat>
              <div class="overview-profile" flat>
                <div class="history-content">
                  <GalleryContent v-if="hasPictures" :images="selectedProfile.galleryImages" />
                  <div v-else class="history-content">
                    <h3>Bisher keine Galerie angelegt.</h3>
                  </div>

                  <LinkCard v-if="hasLinks" :links="selectedProfile.videolinks" :title="'Videos'" />
                  <LinkCard v-if="hasArticles" :links="selectedProfile.newslinks" :title="'Zeitungsartikel'" />
                </div>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-tab href="#Übersicht">Spielerdaten</v-tab>
        <v-tab href="#Karriere">Karriere</v-tab>
        <v-tab href="#Gallery">Galerie</v-tab>
      </v-tabs>
    </div>
    <div
      v-if="this.showMatchButtons && (!this.user_data.already_matched || (this.user_data.already_matched && !this.user_data.already_matched.includes(selectedProfile.id)))"
      :class="[ {'button-box-active': show?true:false},'button-box-fixed']"
    >
      <v-btn
        v-if="isApplication"
        @click="deleteDialog = true"
        color="red"
        class="menu-button main-small"
        style="color: white;"
      >
        NO MATCH!
        <!-- <v-icon>person</v-icon> -->
      </v-btn>
      <v-btn
        @click="matchPlayer(selectedProfile, 'users', userType)"
        class="menu-button main main-small">
        MATCH NOW!
        <!-- <v-icon>person</v-icon> -->
      </v-btn>
    </div>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline">Connect-Anfrage ablehnen</v-card-title>

        <v-card-text class="text-xs-left">
          Möchtest du die Connect-Anfrage wirklich ablehnen?
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center;">
          <v-btn text @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn
            :loading="loading"
            color="red white--text"
            text
            @click="reject(selectedProfile)"
          >Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { db } from '@/db';
import HistoryCard from '@/components/HistoryCard';
import GalleryContent from '@/components/settings/GalleryContent';
import LinkCard from '@/components/settings/LinkCard';
import UserData from '../profile/UserData';
import UserBio from '../profile/UserBio';
import matchMixin from '../../mixins/match';

export default {
  name: 'player-match-sheet',

  mixins: [matchMixin],

  components: {
    HistoryCard,
    GalleryContent,
    LinkCard,
    UserData,
    UserBio,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedProfile: {
      type: Object,
      default: () => {},
    },
    isApplication: {
      type: Boolean,
      default: false,
    },
    showMatchButtons: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    tab: null,
    deleteDialog: false,
    loading: false,
  }),

  computed: {
    ...mapState([
      'userType',
    ]),

    hasGallery() {
      const hasLinks = this.selectedProfile.videolinks[0].title !== ''
        || this.selectedProfile.videolinks[0].title !== '';
      const hasArticles = this.selectedProfile.newslinks[0].title !== ''
        || this.selectedProfile.newslinks[0].title !== '';
      const hasPictures = this.selectedProfile.galleryImages[0] !== ''
        || this.selectedProfile.galleryImages[1] !== ''
        || this.selectedProfile.galleryImages[2] !== ''
        || this.selectedProfile.galleryImages[3] !== '';
      return !(!hasLinks && !hasPictures && !hasArticles);
    },

    sortedHistory() {
      let sorted = [];
      if (this.selectedProfile.history) {
        sorted = this.selectedProfile.history.sort((a, b) => (a.season < b.season ? 1 : b.season < a.season ? -1 : 0));
      }
      return sorted;
    },
  },

  methods: {
    async reject(selectedProfile) {
      this.loading = true;
      const applicationsWithoutCurrentTeam = this.user_data.applications.filter(
        application => application !== selectedProfile.id,
      );

      this.user_data.applications = applicationsWithoutCurrentTeam;

      const filteredPlayers = this.$store.state.playersConnected.filter(
        player => player && player.id !== selectedProfile.id,
      );

      this.$store.commit('updatePlayersConnected', filteredPlayers);

      const updatedData = {
        applications: applicationsWithoutCurrentTeam,
      };
      if (this.user_data.newApplication && selectedProfile.id === this.user_data.newApplication.id) {
        updatedData.newApplication = null;
        this.user_data.newApplication = null;
      }

      const withoutMyTeam = selectedProfile.applied_teams.filter(t => t !== this.user_data.id);
      console.log({ withoutMyTeam }, this.user_data.id);
      await db.collection('users')
        .doc(selectedProfile.id)
        .update({
          applied_teams: withoutMyTeam,
        });

      db.collection('teams')
        .doc(this.user_data.id)
        .update(updatedData)
        .then(() => {
          this.loading = false;
          this.$emit('close');
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.settings-wrapper {
  padding-top: 60px;
  overflow: hidden;
}
</style>
